import React from 'react';
import InfiniteTable, { InfiniteTableProps } from '../Display/InfiniteTable';
import { API } from 'aws-amplify';
import { Subtract } from 'utility-types';

type DynamoInfiniteTableProps<T> = InfiniteTableProps<T> & {
  dataFetcher: (
    lastKeyRetrieved: { [key: string]: string } | null,
    pageSize: number,
  ) => Promise<{ data: T[]; lastKeyRetrieved: { [key: string]: string } | null }>;
  pageSize: number;
};

type InjectedProps<T> = {
  loadMore: () => Promise<void>;
  hasMoreData: boolean;
  loading: boolean;
  data: T[];
};

type State<T> = {
  lastKeyRetrieved: { [key: string]: string } | null;
  data: T[];
  loading: boolean;
};

class DynamoInfiniteTable<RecordType> extends React.Component<
  Subtract<DynamoInfiniteTableProps<RecordType>, InjectedProps<RecordType>>,
  State<RecordType>
> {
  static defaultProps = {
    pageSize: 20,
  };

  state = {
    lastKeyRetrieved: null,
    loading: false,
    data: [],
  };
  componentDidMount(): void {
    if (this.props.tableId) {
      // Add listener for table refresh
      window.addEventListener(`refresh#${this.props.tableId}`, async () => {
        this.setState(
          {
            lastKeyRetrieved: null,
            data: [],
          },
          () => {
            this.loadMore();
          },
        );
      });
    }
  }
  loadMore = async (): Promise<void> => {
    this.setState({ loading: true });
    try {
      const response = await this.props.dataFetcher(this.state.lastKeyRetrieved, this.props.pageSize);
      if (response.data) {
        this.setState((state: State<RecordType>) => ({
          lastKeyRetrieved: response.lastKeyRetrieved,
          data: [...state.data, ...response.data],
          loading: false,
        }));
        return;
      }
    } catch (e) {}
    this.setState({ loading: false });
  };
  render(): React.ReactElement {
    return (
      <InfiniteTable
        {...this.props}
        loadMore={this.loadMore}
        hasMoreData={this.state.lastKeyRetrieved !== null}
        loading={this.state.loading}
        data={this.state.data}
      />
    );
  }
}

export default DynamoInfiniteTable;
